export default __webpack_public_path__ + "static/media/tube_rotor_placed.931670ef.svg";